<template>
  <div>
    <v-app-bar class="portalHeader" dense>
      <v-btn icon @click="openDrawer">
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </v-btn>
      <div class="sites_name_wrapper">
        <v-btn @click="openSearchDialog">
          <div class="sites_name">
            {{ currentSite ? currentSite.name : "-" }}
          </div>
          <v-spacer></v-spacer>
          <v-icon> mdi-menu-down </v-icon>
        </v-btn>
      </div>
      <div class="portalHeader-title">
        <img
          class="portalHeader-logo"
          src="@/assets/rakuraku2.png"
          @click="onClickLogo"
        />
        <div class="portalHeader-label">（終了現場）</div>
      </div>
      <v-tabs right v-model="active_tab">
        <v-tab
          v-for="val in HEADER_MENU_END_USE_FIELD_ARRAY"
          :key="val.id"
          @change="(menu = val), onChange(val.id)"
          >{{ val.name }}</v-tab
        >
      </v-tabs>
    </v-app-bar>
    <Popup width="500px" :dialog="isShowSearchDialog">
      <FieldsSelectDialog
        title="現場管理画面"
        :gotoMaster="true"
        :formValues="formValues"
        @formUpdate="formUpdate"
        @onSearch="searchSite"
        @close="isShowSearchDialog = false"
      />
    </Popup>
  </div>
</template>

<script>
import { Store } from "@/store/Store.js";
import {
  HEADER_MENU_ITEMS_INHOUSE,
  HEADER_MENU_END_USE_FIELD_ARRAY,
} from "@/constants/GLOBALHEADER";
import FieldsSelectDialog from "./components/FieldsSelectDialog";
import Popup from "@/components/common/Popup.vue";

export default {
  components: {
    FieldsSelectDialog,
    Popup,
  },
  data() {
    return {
      HEADER_MENU_END_USE_FIELD_ARRAY,
      active_tab: 0,
      formValues: {
        items: [],
        keyword: "",
        main_contractor_id: null,
        end_use_flg: null,
        selected: null,
      },
      isShowSearchDialog: false,
      siteId: null,
    };
  },
  async mounted() {
    this.$watch(
      () => Store.getters[`GlobalHeader/getInHouseMenuId`],
      (menuId) => {
        this.active_tab = menuId;
      },
      {
        immediate: true,
      }
    );
    this.$watch(
      () => Store.getters[`GlobalHeader/getSiteList`],
      (data) => {
        const siteList = [...data];
        this.formValues.items = siteList;
      },
      {
        immidiate: true,
        deep: true,
      }
    );
  },
  computed: {
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    currentSite() {
      return Store.state.GlobalHeader.selectedSite;
    },
  },
  methods: {
    onChange(menuId) {
      const selectedMenu = this.HEADER_MENU_ITEMS_FIELD_ARRAY.find((item) => {
        return item.id === menuId;
      });
      this.$router.push(selectedMenu.path).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    openDrawer() {
      Store.dispatch("Drawer/show");
    },
    async openSearchDialog() {
      const result = await Store.dispatch("GlobalHeader/searchSites", {
        keyword: "",
        main_contractor_id:
          this.loginUser.role == 9 ? this.loginUser.main_contractor_id : null,
      });
      if (result.hasError) {
        Store.dispatch("Error/show", {
          status: 200,
          message: result.data.message,
        });
      }
      this.isShowSearchDialog = true;
    },
    async searchSite() {
      const { keyword, main_contractor_id, end_use_flg } = this.formValues;
      const result = await Store.dispatch("GlobalHeader/searchSites", {
        keyword,
        end_use_flg,
        main_contractor_id,
      });
      if (result.hasError) {
        Store.dispatch("Error/show", {
          status: 200,
          message: result.data.message,
        });
      }
    },
    formUpdate(values) {
      this.formValues = { ...values };
      if (this.formValues.selected) {
        Store.dispatch("GlobalHeader/setSite", {
          field_id: this.formValues.selected,
        });
        this.isShowSearchDialog = false;
        const formValues = {
          items: [],
          keyword: "",
          selected: null,
        };
        this.formValues = formValues;
      }
    },
    onClickLogo() {
      this.$router
        .push(HEADER_MENU_ITEMS_INHOUSE.MACHINES.path)
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/themes.scss";

::v-deep .v-toolbar__content {
  background-color: $secondary_color;
}
.v-tab {
  color: $secondary_color !important;
}
.v-tabs ::v-deep .v-tab--active {
  border-radius: 0 !important;
  border: 0 solid $secondary_color;
  border-bottom: 2px solid $secondary_color;
}
.v-tabs ::v-deep .v-tabs-slider-wrapper {
  color: $secondary_color !important;
}
.v-app-bar__nav-icon ::v-deep .v-icon {
  color: $primary_color !important;
}
.portalHeader-label {
  color: $primary_color;
}
</style>
